import React from "react";
import ClientCard from "../components/cards/ClientCard";
import Navigation from "../components/layout/Navigation";
import { TabTitle } from "../utils/helperFunctions";

//Project's information to display
function Clients(props) {
  TabTitle("Clients");

  //Projects to map through
  let contracts = [
    //Contracts
    // {
    //   img: "img/clients/fisher.webp",
    //   location: "Costa Mesa, Florida",
    //   href: "https://www.fisherprotectionservices.com",
    //   name: "Fisher Protection Services",
    //   meta: "Register.com's Website builder",
    //   desc: "This client came to me with a half built website, built around 2010, which is still hosted on Register.com.  It started off with a redesign of his website, but as time went on I was tasked with setting up a new domain and hosting plan on his hosting platform.",
    //   desc2:
    //     "I assisted with technical support for getting their hosting reconfigured and chose a template from the website builder tool to implement his updated business details as well as set up an external link for EMCall.  A future goal of ours is to redesign their business logo, when time and resources permit.",
    //   created: "May 17th, 2022",
    //   lastUpdated: " ",
    //   github: "null",
    // },
    {
      img: "img/clients/ss&b2.webp",
      location: "Springfield, MO",
      href: "https://www.ssbhc.com",
      name: "SS&B Heating & Cooling",
      meta: "Next JS, Typescript, Sanity.IO Bootstrap",
      desc: "SS&B reached out to me after they had a previous developer quit on them.  I did reach out to them beforehand, in regards to work they needed done but they already found someone.",
      desc2:
        "I provided the client with the following services: Technical Knowledge about how to access their code, how to add members to their Sanity Studio CMS, Adding new marketing scripts from Google and Bing, Adding schemas to their CMS platform, Refactoring their project, Payment Portal, Videos Page, as well as Improving Scoring for SEO, Best Practices & Accessability in correspondence to Page Speed Insights.",
      created: "October 31st, 2022",
      lastUpdated: " Updated: Nov 18th 2021",
      github: "null",
    },

    // End Contracts
  ];

  return (
    <div className="" style={{ backgroundColor: "black", height: "100vh" }}>
      <Navigation />

      <div className="ui very padded relaxed grid " id="clients">
        <div className="ui link cards large container two stackable grid">
          {contracts.map((contract) => (
            <ClientCard data={contract} />
          ))}
          <br></br>
        </div>
      </div>
    </div>
  );
}

export default Clients;
